module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "dashboard"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _c('div', {
      staticClass: "master_view"
    }, [_c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "10vh"
      }
    }, [_c('h1', [_vm._v("Hola " + _vm._s(_vm.user.nickname) + " !")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "18vh"
      }
    }, [_c('h2', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Bonell+Dòriga")])])], 1)])]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d8a6c8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/Dashboard.vue
// module id = 2171
// module chunks = 0